import { ReactElement, useState } from 'react'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import { PrivacyPolicy, TermsAndConditions } from 'components/common/Compliance'

const Footer = (): ReactElement => {
    const [showTermsAndConditions, setShowTermsAndConditions] =
        useState<boolean>(false)
    const [showPrivacyPolicy, setShowPrivacyPolicy] = useState<boolean>(false)
    const { t } = useTranslation()

    const toggleTermsAndConditions = (): void => {
        setShowTermsAndConditions((value) => !value)
    }

    const togglePrivacyPolicy = (): void => {
        setShowPrivacyPolicy((value) => !value)
    }

    if (showTermsAndConditions) {
        return <TermsAndConditions onClose={toggleTermsAndConditions} />
    }

    if (showPrivacyPolicy) {
        return <PrivacyPolicy onClose={togglePrivacyPolicy} />
    }

    return (
        <div data-testid="footer">
            <div>
                <List>
                    <ListItem data-testid="gopay-trademark">
                        <CopyrightText>
                            ©{new Date().getFullYear()} GoPay
                        </CopyrightText>
                    </ListItem>
                    <ListItem data-testid="privacy-policy">
                        <Link onClick={togglePrivacyPolicy}>
                            {t('labelPrivacyPolicy')}
                        </Link>
                    </ListItem>
                    <ListItem data-testid="terms-of-service">
                        <Link onClick={toggleTermsAndConditions}>
                            {t('labelTermsOfService')}
                        </Link>
                    </ListItem>
                </List>
            </div>
        </div>
    )
}

const List = styled.ul`
    display: flex;
    width: 100%;
    justify-content: center;
    font-size: 0;
`

const ListItem = styled.li`
    &:not(:last-child) {
        margin-right: 12px;
        border-right: 1px solid #b3bac1;
    }
`

const listItemStyle = `
    font-style: normal;
    color: #616e7a;
    font-size: 12px;
    line-height: 16px;
    font-weight: 600;
    cursor: pointer;
    padding-right: 12px;
`

const Link = styled.a`
    ${listItemStyle}
`
const CopyrightText = styled.span`
    ${listItemStyle}
`

export default Footer
